import React, { Component } from 'react';
import { Button, Input, Form, FormGroup, Label } from 'reactstrap';
import { connect } from 'react-redux';
import { addCategory, addSubcategory } from '../../../store/editStoreActions';
import { bindActionCreators } from 'redux';
import './CategoryForm.css';
class CategoryForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: {
        id: null
      },
      type: this.props.type
    };
  }

  add(data, type, index) {
    this.setState({ data: {} });
    this.props.toggle();
    if (type === 'category') {
      return this.props.addCategory(data);
    }
    this.props.addSubcategory(index, data);
  }

  handleChange(e, id) {
    let { value } = e.target;
    let inputId = id;
    let nameToId = this.state.data.id;

    if (!inputId) {
      inputId = e.target.id;
    }

    if (inputId === 'name') {
      nameToId = value.replace(/\s+/g, '-').toLowerCase();
    }

    this.setState({
      data: { ...this.state.data, [inputId]: value, id: nameToId }
    });
  }

  renderTitleInput(name) {
    return (
      <FormGroup className="flex-wrapper flex-100">
        <Label for="name">Name</Label>
        <Input
          id="name"
          onChange={e => this.handleChange(e)}
          value={name || ''}
        />
      </FormGroup>
    );
  }

  renderDescriptionInput(description) {
    return (
      <FormGroup className="flex-100">
        <Label>Description</Label>
        <Input
          id="description"
          type="textarea"
          rows="4"
          onChange={e => this.handleChange(e)}
          value={description || ''}
        />
      </FormGroup>
    );
  }

  renderSkusInput(skus) {
    return (
      <FormGroup className="flex-100">
        <Label>Skus</Label>
        <Input
          id="skus"
          type="textarea"
          rows="3"
          onChange={e => this.handleChange(e)}
          value={skus || ''}
        />
      </FormGroup>
    );
  }

  renderImageInput(image) {
    return (
      <FormGroup>
        <Label>
          Tile image <small>{this.props.imageBasePath}</small>
        </Label>
        <Input
          id="image"
          onChange={e => this.handleChange(e)}
          value={image || ''}
        />
      </FormGroup>
    );
  }

  renderFeatureImageInput(featureImage) {
    return (
      <FormGroup>
        <Label>
          Feature image <small>{this.props.imageBasePath}</small>
        </Label>
        <Input
          id="featureImage"
          onChange={e => this.handleChange(e)}
          value={featureImage || ''}
        />
      </FormGroup>
    );
  }

  renderRecommendationsInput(recommendations) {
    return (
      <FormGroup className="flex-100">
        <Label>Recommendations category</Label>
        <Input
          id="recommendations"
          onChange={e => this.handleChange(e)}
          value={recommendations || ''}
          placeholder={'e.g. Web_COMPUTER_DESKS'}
        />
      </FormGroup>
    );
  }

  renderFormInput(type) {
    const { data } = this.state;

    switch (type) {
      case 'category':
        return (
          <React.Fragment>
            {this.renderTitleInput(data.name)}
            {this.renderDescriptionInput(data.description)}
            {this.renderRecommendationsInput(data.recommendations)}
          </React.Fragment>
        );
      default:
        return (
          <React.Fragment>
            {this.renderTitleInput(data.name)}
            {this.renderImageInput(data.image)}
            {this.renderFeatureImageInput(data.featureImage)}
            {this.renderDescriptionInput(data.description)}
            {this.renderSkusInput(data.skus)}
            {this.renderRecommendationsInput(data.recommendations)}
          </React.Fragment>
        );
    }
  }

  render() {
    const { data, type } = this.state;
    const { toggle, activeCategory } = this.props;

    return (
      <div className="form-wrapper">
        <Form className="flex-form" onSubmit={evt => evt.preventDefault()}>
          {type && this.renderFormInput(type)}

          <div className="form-buttons">
            {type === 'category' ? (
              <Button
                color="primary"
                onClick={() => this.add(data, type)}
                disabled={!data.name}
              >
                Add category{' '}
              </Button>
            ) : (
              <Button
                color="primary"
                onClick={() => this.add(data, type, activeCategory)}
                disabled={!data.name}
              >
                Add subcategory
              </Button>
            )}
            <Button color="link" onClick={toggle}>
              Cancel
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = ({ activeStore }) => ({
  activeStore: activeStore.activeStore
    ? activeStore[activeStore.activeStore]
    : null,
  activeStoreId: activeStore.activeStore,
  imageBasePath:
    activeStore.activeStore && activeStore[activeStore.activeStore]
      ? activeStore[activeStore.activeStore].imageBasePath
      : null
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      addCategory,
      addSubcategory
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CategoryForm);



// WEBPACK FOOTER //
// ./src/components/categories/CategoryForm/CategoryForm.js